
import React from "react";
import { connect } from "react-redux";

import Members from "./Members/Members";
import Search from "./Search/Search";
import RemoveMember from "./Modal/RemoveMember/RemoveMember";
import Archived from "../../../ArchivedConfirmation/ArchivedConfirmation";

@connect( store => {
    return {
        conversations: store.conversations
    }
})

class MembersTab extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            deleteID: null,
            deleteAction: null
        }
    }

    render() {
        const { conversations, isAdmin} = this.props;
        const selected = conversations.selected;
        const onRemoveMemberModal = ( id, type ) => {
            this.setState({ ...this.state, deleteID: id, deleteAction: type });
        }
        return (
            <div class="detailsWrapper">
                { isAdmin && !selected.isArchived && (
                    <div class="workstreamListInput">
                        <Search  isAdmin={isAdmin}/>
                    </div>
                )}
                <div class="membersList">
                    <Members onRemoveMemberModal={ onRemoveMemberModal } isAdmin={ this.props.isAdmin } /> 
                </div>

                <RemoveMember deleteID={ this.state.deleteID } deleteAction={ this.state.deleteAction } />
            </div>
        );
    }
}

export default MembersTab;